import actions from './actions';
import mutations from './mutations';
import getters from './getters';
import Upload from './upload';
import Creator from './creator';
import Preview from './preview';
import Manage from './manage';
import Markup from './markup';
import Search from './search';
import Filter from './filter';
import Settings from './settings';
import Access from './access';
import { state } from './state';

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    modules: {
        upload: Upload,
        creator: Creator,
        preview: Preview,
        manage: Manage,
        markup: Markup,
        settings: Settings,
        access: Access,
        search: Search,
        filter: Filter,
    }
};